if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span.cart-text');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            addOptions(); //オプションをカートに追加する
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
                /*--------------------------------------------
        // オプション追加
        --------------------------------------------*/
        function addOptions(){
          const kumitate_meta = document.getElementById('option_kumitate');
          const kaisyu_meta = document.getElementById('option_kaisyu');
          const wrapping_meta = document.getElementById('option_wrapping');

          const kumitate_item = kumitate_meta ? {id: kumitate_meta.getAttribute('data-variant'), quantity: 1} : null;
          const kaisyu_item = kaisyu_meta ? {id: kaisyu_meta.getAttribute('data-variant'), quantity: 1} : null;
          const wrapping_item = wrapping_meta ? {id: wrapping_meta.getAttribute('data-variant'), quantity: 1} : null;

          const kumitate_option_value = kumitate_meta ? document.getElementById('option_kumitate').value : 0;
          const kaisyu_option_value = kaisyu_meta ? document.getElementById('option_kaisyu').value : 0;
          const wrapping_option_value = wrapping_meta ? document.getElementById('option_wrapping').value : 0;


          if(kaisyu_meta && kaisyu_option_value == 2){
            kaisyu_item.id = kaisyu_meta.getAttribute('data-variant2');
          }

          console.log({kaisyu_option_value})
          console.log({kaisyu_item})

          if(kumitate_item != null && kumitate_item.id == ''){
            kumitate_item.id = kumitate_meta.getAttribute('data-gid');
          }
          if(kaisyu_item != null && kaisyu_item.id == ''){
            kaisyu_item.id = kaisyu_meta.getAttribute('data-gid');
          }
          if(wrapping_item != null && wrapping_item.id == ''){
            wrapping_item.id = wrapping_meta.getAttribute('data-gid');
          }

          const customItems = [];

          if( kumitate_option_value == 1){
            customItems.push(kumitate_item);
          }
          if( kaisyu_option_value == 1 || kaisyu_option_value == 2){
            customItems.push(kaisyu_item);
          }
          if( wrapping_option_value == 1){
            customItems.push(wrapping_item);
          }

          // console.log(customItems);

          if(customItems.length > 0){
            const formData = {
              'items': customItems
            };

            fetch(`${routes.cart_add_url}.js`,{
              method: "POST",
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then((response) => {
              getCart();
              return response.json()
            })
            .catch(error => {
              console.log(error);
            });
            // document.addOptionForm.submit();
          }

        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
